import { render, staticRenderFns } from "./PricingListPriceDetails.vue?vue&type=template&id=565b608f&"
import script from "./PricingListPriceDetails.vue?vue&type=script&lang=js&"
export * from "./PricingListPriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./PricingListPriceDetails.vue?vue&type=style&index=0&id=565b608f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports